module.exports = __webpack_public_path__ + "static/media/sky_banner.467920e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/sky_banner.png
// module id = 211
// module chunks = 0